import { createStore } from 'vuex';
import users from './modules/users';
import options from './modules/options';
import application from './modules/application';
import employees from './modules/employees';
import timeTracker from './modules/time-tracker';
import tasksAdmin from './modules/tasks';
import blog from './modules/blogs';
import teams from './modules/teams';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    users,
    options,
    application,
    employees,
    timeTracker,
    tasksAdmin,
    blog,
    teams,
  },
});
